// IE 2026 10 18 / ODOO-5800 (Igor, M03 вернулся на схему ФЛАЖКАМИ: политика сегмента 0GJ_001 doc.approval.use=false, замок / порядок — правила
// условного оформления записи виджета, бэк при клике по флажку не зовётся — только при Save). Чистая логика «локальных флажков» без политики:
// порядок шагов ПМ → БЮМ → МД берётся не из doc._approval (его у отчёта без политики нет), а из колонок грида с полями ApprovedPM / ApprovedBUM /
// ApprovedMD. Единый выключатель для всех правок схемы флажков на фронте — fe.ux.m03FlagsLocal (дефолт ВКЛ; выкл — как до правки: без политики
// шагов нет, порядок / итоги / каскад по флажкам не считаются). Юнит — tests/unit/m03FlagsLocal.test.mjs.
import { approvalFlagSteps } from '@/utils/approval'

export const M03_FLAGS_LOCAL_FLAG = 'fe.ux.m03FlagsLocal'

// setting — функция (key, default) → значение (AttrGrid: fmtSetting / store.setting); нет функции / ошибка — ВКЛ
export function m03FlagsLocal_on(setting) {
    try { return typeof setting === 'function' ? setting(M03_FLAGS_LOCAL_FLAG, true) !== false : true } catch (e) { return true }
}

// поля флажков шагов M03 в порядке согласования (роль права — access-<поле>, как в правилах CF записи 1coh_001)
export const M03_FLAG_FIELDS = ['ApprovedPM', 'ApprovedBUM', 'ApprovedMD']

const str = (x) => (x === undefined || x === null) ? '' : String(x)
const FLAG_BINDING_PREFIX = /^(doc\.data\.|data::|data\.|doc\.)/

// поле флажка из привязки колонки ('data::ApprovedPM' → 'ApprovedPM'); не флажок M03 — ''
export function m03FlagField(binding) {
    const b = str(binding), m = FLAG_BINDING_PREFIX.exec(b), f = b.slice(m ? m[0].length : 0)
    return M03_FLAG_FIELDS.includes(f) ? f : ''
}

// карта шагов схемы флажков без политики — [{order, field, role}] (как approvalFlagSteps), по привязкам колонок грида;
// меньше двух колонок флажков — это не M03, шагов нет
export function m03LocalFlagSteps(bindings) {
    if (!Array.isArray(bindings)) return []
    const present = new Set(bindings.map(m03FlagField).filter(Boolean))
    const out = M03_FLAG_FIELDS.filter(f => present.has(f)).map((f, i) => ({ order: i + 1, field: f, role: 'access-' + f }))
    return out.length >= 2 ? out : []
}

// шаги флажков отчёта: политика сегмента (doc._approval) — её шаги, как раньше; политики нет — локальная карта по колонкам (при включённом флаге)
export function m03FlagSteps(da, bindings, setting) {
    const s = approvalFlagSteps(da)
    if (s.length) return s
    return m03FlagsLocal_on(setting) ? m03LocalFlagSteps(bindings) : []
}

// IE 2026 10 18 / ODOO-5800 (Igor, остаток п.1: снять БЮМ сразу после снятия МД — отказ «не можна змінити після погодження МД» по застарелому классу CF
// noedit-approval-locked, посчитанному при МД=true; класс живёт в DOM / кэше ячейки до перерисовки CF). Живое решение по флажку шага по ТЕКУЩИМ значениям
// флажков строки (read(binding) — в том числе несохранённое): стоят флажки шагов ВЫШЕ — заперт (approval-locked, later = кто запер); снят сам и не стоят
// шаги ниже — по порядку (approval-order, missing = кого не хватает); иначе — редактируем (снять свой / поставить следующий). Символизм: класс CF «locked»
// считается устаревшим, когда живые значения выше по порядку уже сняты; каскада при снятии нет (только своя ячейка). null — не флажок схемы / шагов нет
export function m03FlagLiveDecision(binding, steps, read) {
    if (!Array.isArray(steps) || !steps.length || typeof read !== 'function') return null
    const b = str(binding), m = FLAG_BINDING_PREFIX.exec(b), pre = m ? m[0] : '', field = b.slice(pre.length)
    const k = steps.findIndex(s => s.field === field)
    if (k < 0) return null
    const on = (f) => { const v = read(pre + f); return v === true || v === 1 || v === 'true' || v === '1' }
    const later = steps.slice(k + 1).filter(s => on(s.field)).map(s => s.field)
    if (later.length) return { editable: false, reason: 'approval-locked', later, missing: [] }
    const missing = on(field) ? [] : steps.slice(0, k).filter(s => !on(s.field)).map(s => s.field)
    if (missing.length) return { editable: false, reason: 'approval-order', later: [], missing }
    return { editable: true, reason: null, later: [], missing: [] }
}
